function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedin2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    width: "30px",
    height: "30px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface289745313"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 9 25 L 4 25 L 4 10 L 9 10 Z M 6.5 8 C 5.117188 8 4 6.878906 4 5.5 C 4 4.117188 5.121094 3 6.5 3 C 7.878906 3 9 4.121094 9 5.5 C 9 6.878906 7.878906 8 6.5 8 Z M 27 25 L 22.191406 25 L 22.191406 17.699219 C 22.191406 15.960938 22.160156 13.71875 19.695312 13.71875 C 17.191406 13.71875 16.804688 15.617188 16.804688 17.574219 L 16.804688 25 L 12 25 L 12 9.988281 L 16.613281 9.988281 L 16.613281 12.039062 L 16.679688 12.039062 C 17.320312 10.859375 18.890625 9.617188 21.230469 9.617188 C 26.101562 9.617188 27 12.726562 27 16.765625 Z M 27 25 "
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin2);
export default __webpack_public_path__ + "static/media/linkedin-2.b7cafebc84962c9779373e12ee6b07a8.svg";
export { ForwardRef as ReactComponent };